import type { RouteDefinition } from "../../../routes/routes";
import SignupLayout from "../layout/SignupLayout";

export const OnboardingRoutes: RouteDefinition[] = [
  {
    path: "/",
    layout: "/",
    component: SignupLayout,
    application: "Admin",
  },
];
